module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/mixer-89c0f423949eccb98ec546023c8790a2.svg";